/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

//components
import { Modal } from "@mui/material";
import FirstPage from "./first-page";
import SecondPage from "./countdown";
import ErrorPage from "../common/errorPage";
import SuccessPage from "../common/successPage";

import { FETCH_ORDER_DETAILS } from "graphql";
import { apiCall, toggleLoading } from "store/actions";
import { fetchBaseURL } from "utils";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    outline: "none",
    boxShadow: 24,
    p: 4,
};

export default function ({ loading }) {
    const dispatch = useDispatch();
    const { orderId } = useParams();

    const [page, setPage] = useState(0);
    const [error, setError] = useState("");
    const [details, setDetails] = useState({
        orderId: orderId,
        walletAddress: "",
        amount: 0,
        merchant: "",
        currency: "",
        network: "",
        baseUrl: fetchBaseURL(orderId, "order_"),
    });

    const handlePage = (data) => {
        setPage(data);
    };

    const handlePaymentDetails = (data) => {
        setDetails(data);
    };

    useEffect(() => {
        fetchOrderDetails();
    }, []);

    const fetchOrderDetails = async () => {
        dispatch(toggleLoading(true));
        const response = await apiCall(details.baseUrl, FETCH_ORDER_DETAILS, { orderId: orderId });

        if (!response.status) {
            dispatch(toggleLoading(false));
            setError(response.data?.message ?? "Order not working");
            return setPage(3);
        }

        const {
            data: { merchant_id, amount, currency },
        } = response.data?.list_order_details;

        setDetails({
            ...details,
            merchant: merchant_id?.name ?? "",
            amount: amount,
            currency: currency,
        });
        dispatch(toggleLoading(false));
        return handlePage(1);
    };

    return (
        <>
            <div className="container mx-auto px-4 h-full">
                <div className="flex content-center items-center justify-center h-full">
                    <div className="w-full lg:w-4/12 px-4">
                        <Modal open={!loading}>
                            <div
                                style={style}
                                className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0"
                            >
                                {page === 1 ? (
                                    <FirstPage
                                        dispatch={dispatch}
                                        handlePage={handlePage}
                                        handlePaymentDetails={handlePaymentDetails}
                                        paymentDetails={details}
                                    />
                                ) : page === 2 ? (
                                    <SecondPage handlePage={handlePage} paymentDetails={details} />
                                ) : page === 3 ? (
                                    <ErrorPage error={error} />
                                ) : page === 4 ? (
                                    <SuccessPage />
                                ) : null}
                            </div>
                        </Modal>
                    </div>
                </div>
            </div>
        </>
    );
}
